import { createFileRoute } from '@tanstack/react-router'

import Org from 'pages/Org'

export const Route = createFileRoute('/_auth/orgs/$id/')({
  component: Org,
})
